import React from "react";
import "./Feed.css";
import Einstein from "../../components/Einstein/Einstein";

export default function Dashboard() {
    return (
        <div>
            <div className="feed-center">
                <Einstein />
                {/* <img src="/img/einstein.svg" /> */}
            </div>

            <div className="feed-right-menu">
                <div className="feed-right-menu-section">
                    <div className="feed-right-menu-title">
                        Meu desempenho
                        <div className="feed-performance-date">Mês</div>
                    </div>
                    <div className="feed-performance-block">
                        Faturado
                        <div className="feed-performance-value">
                            <small>R$</small> 9999
                            <div className="feed-percentage positive">25%</div>
                        </div>
                    </div>
                    <div className="feed-performance-block">
                        Vendas
                        <div className="feed-performance-value">
                            177
                            <div className="feed-percentage negative">25%</div>
                        </div>
                    </div>
                    <div className="feed-performance-block">
                        Lucro
                        <div className="feed-performance-value">
                            <small>R$</small> 9999
                            <div className="feed-percentage positive">25%</div>
                        </div>
                    </div>
                    <div className="feed-performance-details">Mostrar mais</div>
                </div>
                <div className="feed-right-menu-section">
                    <div className="feed-right-menu-title">Últimos pedidos</div>
                </div>
            </div>
        </div>
    );
}
